function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 27.4945,
  cy: 8.1998,
  rx: 5.85,
  ry: 5.4,
  stroke: "black",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.0894 23.7221C18.4151 22.9773 17.7343 20.9539 18.8148 19.4739C20.7805 16.7815 23.9609 15.0322 27.5498 15.0322C31.1387 15.0322 34.3191 16.7815 36.2848 19.4739C37.3653 20.9539 36.6845 22.9773 35.0102 23.7221C32.7304 24.7362 30.2059 25.2998 27.5498 25.2998C24.8937 25.2998 22.3692 24.7362 20.0894 23.7221Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.2848 19.4739L34.6694 20.6532L36.2848 19.4739ZM20.0894 23.7221L19.2765 25.5494L20.0894 23.7221ZM20.4302 20.6533C22.0355 18.4544 24.6265 17.0322 27.5498 17.0322V13.0322C23.2953 13.0322 19.5256 15.1086 17.1995 18.2946L20.4302 20.6533ZM27.5498 17.0322C30.4731 17.0322 33.0641 18.4544 34.6694 20.6532L37.9001 18.2946C35.574 15.1086 31.8043 13.0322 27.5498 13.0322V17.0322ZM34.1973 21.8947C32.1685 22.7972 29.9205 23.2998 27.5498 23.2998V27.2998C30.4914 27.2998 33.2924 26.6752 35.8231 25.5494L34.1973 21.8947ZM27.5498 23.2998C25.1791 23.2998 22.9311 22.7972 20.9023 21.8947L19.2765 25.5494C21.8072 26.6752 24.6082 27.2998 27.5498 27.2998V23.2998ZM34.6694 20.6532C34.8119 20.8483 34.8397 21.0587 34.7712 21.2784C34.6977 21.5141 34.5077 21.7566 34.1973 21.8947L35.8231 25.5494C38.4982 24.3594 39.8338 20.9432 37.9001 18.2946L34.6694 20.6532ZM17.1995 18.2946C15.2658 20.9433 16.6014 24.3594 19.2765 25.5494L20.9023 21.8947C20.5919 21.7566 20.4019 21.5141 20.3284 21.2784C20.2599 21.0587 20.2877 20.8483 20.4302 20.6533L17.1995 18.2946Z",
  fill: "black",
  mask: "url(#path-2-inside-1)"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.2969,
  cy: 7.3,
  rx: 6.75,
  ry: 6.3,
  fill: "black",
  stroke: "black",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("mask", {
  id: "path-5-inside-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.87524 25.8756C0.221833 25.0856 -0.45337 23.0825 0.558172 21.5546C2.85957 18.0783 6.80535 15.7856 11.2866 15.7856C15.7679 15.7856 19.7136 18.0783 22.015 21.5546C23.0266 23.0825 22.3514 25.0856 20.698 25.8756C17.8477 27.2374 14.6562 27.9999 11.2866 27.9999C7.91702 27.9999 4.72552 27.2374 1.87524 25.8756Z"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.87524 25.8756C0.221833 25.0856 -0.45337 23.0825 0.558172 21.5546C2.85957 18.0783 6.80535 15.7856 11.2866 15.7856C15.7679 15.7856 19.7136 18.0783 22.015 21.5546C23.0266 23.0825 22.3514 25.0856 20.698 25.8756C17.8477 27.2374 14.6562 27.9999 11.2866 27.9999C7.91702 27.9999 4.72552 27.2374 1.87524 25.8756Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M20.698 25.8756L19.8357 24.071L20.698 25.8756ZM2.22584 22.6586C4.1726 19.718 7.5044 17.7856 11.2866 17.7856V13.7856C6.10631 13.7856 1.54655 16.4385 -1.10949 20.4505L2.22584 22.6586ZM11.2866 17.7856C15.0688 17.7856 18.4006 19.718 20.3474 22.6586L23.6827 20.4505C21.0267 16.4385 16.4669 13.7856 11.2866 13.7856V17.7856ZM19.8357 24.071C17.249 25.3069 14.3515 25.9999 11.2866 25.9999V29.9999C14.9609 29.9999 18.4464 29.1679 21.5602 27.6802L19.8357 24.071ZM11.2866 25.9999C8.2217 25.9999 5.32425 25.3069 2.73747 24.071L1.01301 27.6802C4.12679 29.1679 7.61234 29.9999 11.2866 29.9999V25.9999ZM20.3474 22.6586C20.6109 23.0567 20.5234 23.7424 19.8357 24.071L21.5602 27.6802C24.1793 26.4288 25.4422 23.1083 23.6827 20.4505L20.3474 22.6586ZM-1.10949 20.4505C-2.86902 23.1083 -1.6061 26.4288 1.01301 27.6802L2.73747 24.071C2.04977 23.7424 1.96228 23.0567 2.22584 22.6586L-1.10949 20.4505Z",
  fill: "black",
  mask: "url(#path-5-inside-2)"
});

var SvgStaff = function SvgStaff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 28,
    viewBox: "0 0 37 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStaff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/staff.defaaee9.svg";
export { ForwardRef as ReactComponent };